/**
 * Given an object and a dotted property path string this function returns
 * getter and setter functions for safely accessing the value. It handles
 * checking parent objects in the chain to avoid null ref errors for get
 * operation, and initializing undefined parent objects for set operations.
 * The property path can also contain square bracket property accessors.
 * The property name inside the bracket may be a string, or an identifier
 * whose value must be provided with the optional `ctx` argument.
 * @param obj object containing properties
 * @param path property path string
 * @param ctx optional context containing identifiers used in property path
 */
export function propertyParser(obj:any, path:string, ctx?:any):IPropertyPart {
   // replace ['prop'] with .prop
   // when contents of [] is not a string, use as identifier for lookup in ctx
   path = path.replace(/\[([^\]]+)\]/g, (match, p1) => {
      if (p1[0] == '"' || p1[0] == "'") {
         return `.${p1.slice(1, -1)}`;
      } else {
         return `.${ctx[p1]}`;
      }
   });

   let parts = path.split('.');
   let part = parts.shift();

   let propPart = new PropertyPart(obj, part);

   if (parts.length > 0) {
      return propertyParser(propPart, parts.join('.'), ctx);
   }

   return propPart;
}

export interface IPropertyPart {
   get():any;
   set(val:any);
}

class PropertyPart {
   constructor(private obj:any, private part:string) { }

   get(isSet?:boolean) {
      let def = isSet ? {} : undefined;
      if (this.obj instanceof PropertyPart) {
         let p = this.obj.get(isSet);
         if (p) {
            if (!p[this.part] && def) {
               p[this.part] = def;
            }

            return p[this.part];
         }
      } else {
         if (!this.obj[this.part] && def) {
            this.obj[this.part] = def;
         }

         return this.obj[this.part];
      }
   }

   set(val:any) {
      this.obj.get(true)[this.part] = val;
   }
}
